import React from 'react';
import { Paper } from '@mui/material';
import { cardSx } from '../../styles/tokens';

const ContentCard = ({ children, sx = {}, ...props }) => (
  <Paper elevation={0} sx={{ ...cardSx, ...sx }} {...props}>
    {children}
  </Paper>
);

export default ContentCard;
